import React from "react";
import { WidgetBox, Empty } from "../components";
import classNames from "classnames";

const SocialFeed = ({ title = "Social Feed" }) => {
    const parseDataFromDOM = () => {
        const [, mainTable] = document.querySelectorAll("div[data-tag='pnlSalesForceChatter'] > table") || [];

        if (!mainTable) {
            return [];
        }

        const innerTable = mainTable.querySelector('table');

        if (!innerTable) {
            return [];
        }

        const rows = innerTable.querySelectorAll('tbody > tr');

        const cols = [];

        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const [, td2] = row.querySelectorAll("td");
            const [p1, p2, p3] = td2.querySelectorAll("p");
            const text1 = [...p1.children].map((o) => o.textContent);
            const text2 = [...p2.children].map((o) => o.textContent);
            const text3 = [...p3.querySelector('i').children].map((o) => o.textContent);

            cols.push({
                text1,
                text2,
                text3
            });
        }

        return cols;
    };

    const data = parseDataFromDOM();

    const listClasses = classNames("v-list", {
        "v-list--overflow": data.length > 3
    });

    const externalLinkContainerClasses = classNames("external-link-container", {
        "external-link-container--overflow": data.length > 3
    });

    return (
        <WidgetBox title={title} noPadding icon="user">
            <div className={listClasses}>
                <div style={{ margin: "0px 45px" }}>
                    <Empty isEmpty={data.length === 0} />
                </div>
                {data.map((o, i) => (
                    <div key={i} className="v-list-item v-list-item--alternate">
                        <p style={{ fontWeight: "bold" }}>{o.text1}</p>
                        <p style={{ fontSize: "14px" }}>{o.text2}</p>
                        <p style={{ fontSize: '13px', color: '#767678' }}>{o.text3}</p>
                    </div>
                ))}
            </div>
            <div className={externalLinkContainerClasses}>
                {/* <Link text="See all items" url="https://www.google.com/" /> */}
            </div>
        </WidgetBox>
    );
};

export default SocialFeed;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/widgets/social-feed.js